import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* settleWithSavingsCheckScenario(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_REQUEST
    })
    
    const res = yield call(Http.get, `charges/${action.payload?.chargeId}/savings-scenario`);

    yield put({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchSettleWithSavingsCheckScenario() {
  yield takeEvery(Constants.GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START, settleWithSavingsCheckScenario);
}
